import { useBreakPoint } from "@/shared/config/use_break_point";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import React from "react";
import { OcrCameraAggregateMode } from "@/shared/config/globals"
import { OcrCameraAggregateModeType } from "@/shared/config/globals";

interface Props {
  onClose: () => void;
  changeStatus: (mode: OcrCameraAggregateModeType) => void;
  imageList: string[];
  resetImageList: () => void;
  photoNumber: number;
  updatePhotoNumber: (num: number) => void;
  mode: OcrCameraAggregateModeType;
  deleteImageUrl: (num: number) => void;
  previousScreen: OcrCameraAggregateModeType;
  photoShootCount: number;
  subtractionPhotoShootCount: () => void;
  resetPhotoShootCount: () => void;
}

export const HeaderOverlay = (props: Props) => {
  const {
    onClose,
    changeStatus,
    imageList,
    resetImageList,
    photoNumber,
    updatePhotoNumber,
    mode,
    deleteImageUrl,
    previousScreen,
    photoShootCount,
    subtractionPhotoShootCount,
    resetPhotoShootCount,
  } = props;

  // 詳細画面へ
  const goDetail = (photoNumber: number) => {
    updatePhotoNumber(photoNumber);
    changeStatus(OcrCameraAggregateMode.Detail);
  };

  // 前の画面へ戻る
  const goBack = () => {
    changeStatus(previousScreen);
  };

  const photoDelete = (num: number) => {
    deleteImageUrl(num);
    subtractionPhotoShootCount();
    if (imageList.length - 1 !== 0) {
      changeStatus(previousScreen);
    } else {
      changeStatus(OcrCameraAggregateMode.Shoot);
    }
  };

  const isPC = useBreakPoint().isPC;


  // サムネイル描画
  const renderThumbnails = () => {
    const thumbnails = imageList;
    const ret = [];
    for (let i = 0; i < thumbnails.length; i++) {
      ret.push(<img src={thumbnails[i]} className="camera-aggregate-modal-header--thumbnail" key={i} />);
    }

    return (
      <div className="camera-thumbnails-box">
        {/* <div> */}
        {/* 撮影後保存された写真を表示 */}
        {ret.map((t, i) => {
          return (
            <div
              className="camera-thumbnail-box"
              onClick={() => {
                goDetail(i);
              }}
              key={i}
            >
              {t}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="camera-header">
      {mode === OcrCameraAggregateMode.Confirm || mode === OcrCameraAggregateMode.Shoot ? (
        <>
          <h1>通帳の画像を撮影 - {photoShootCount + 1} 枚目</h1>
          {/* サムネイル */}
          <div className="camera-thumbnails-area">
            {renderThumbnails()}
          </div>
        </>
      ) : (
        <>
          <BaseRoundButton
            className="camera-back-button"
            onClick={goBack}
          />
          <BaseRoundButton
            className="btn-delete"
            onClick={() => photoDelete(photoNumber)}
          />
          <h1>撮影した画像 - {photoNumber + 1} 枚目</h1>
          {/* 他画面とサイズを合わせるためのサムネイル領域 */}
          <div className="camera-thumbnails-area"></div>
        </>
      )}
    </div>
  );
};
